import { graphql, useStaticQuery } from "gatsby";

export function useGhostSettings() {
    const query = useStaticQuery(graphql`
        query UseGhostSettings {
            allGhostSettings {
                edges {
                    node {
                        ...GhostSettingsFields
                    }
                }
            }
        }
    `);
    return query.allGhostSettings.edges[0].node;
}
